// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 351) return "static/chunks/commons-736fffc5ab0ee24964cc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "806d3d8db00049cb3b76" + ".js";
};